<template>
    <div>
        <vx-card title="Quantidade de clientes que utilizaram o Bitis" collapse-action refresh-content-action :close="false" @refresh="() => refreshData(charts[0])" :download-card-action="table.companies.show" @download="downloadCsvData(charts[0])">
            <div class="w-full flex justify-end">
                <div>
                    <p>Filtrar por empresa</p>
                    <i-select filterable @on-change="() => loadChart(charts[0])" v-model="filters.companies.companyFiltered" clearable class="w-64">
                        <Option v-for="companies in companies" :value="companies.value" :key="companies.value">{{ companies.label }}</Option>
                    </i-select>
                </div>
                <div class="ml-2">
                    <p>Filtrar por vendedor</p>
                    <i-select filterable @on-change="() => loadChart(charts[0])" v-model="filters.companies.salerFiltered" clearable class="w-64">
                        <Option v-for="saler in salers" :value="saler.value" :key="saler.value">{{ saler.label }}</Option>
                    </i-select>
                </div>
                <div>
                    <p>Período</p>
                    <InputNumber @on-change="() => loadChart(charts[0])" :active-change="false" :max="36" :min="1" v-model="filters.companies.period" class="ml-2"></InputNumber>
                </div>
                <div>
                    <p>Tipo de período</p>
                    <i-switch @on-change="() => loadChart(charts[0])" false-value="mensal" size="large" class="m-2"
                                true-value="semanal" v-model="filters.companies.periodFilteredType">
                        <span slot="open">SEM</span>
                        <span slot="close">MEN</span>
                    </i-switch>
                </div>
            </div>
            <div>
                <spin size="large" fix v-show="false"></spin>
                <bar :options="companyGraphOptions" @click="(options) => getDetails(options, charts[0])"></bar>
            </div>
            <div style="max-height:32rem;" class="overflow-auto" @scroll="handleScroll" v-show="table.companies.show">
                <i-table :ref="charts[0]" :columns="table.companies.columns" :data="table.companies.data" :loading="table.companies.loading" v-show="table.companies.show"></i-table>
            </div>
        </vx-card>
        <vx-card title="Quantidade de Usuários que utilizaram o Bitis" collapse-action refresh-content-action :close="true" @refresh="() => refreshData(charts[1])" :download-card-action="table.users.show" @download="downloadCsvData(charts[1])">
            <div class="w-full flex justify-end">
                <div>
                    <p>Filtrar por empresa</p>
                    <i-select filterable @on-change="() => loadChart(charts[1])" v-model="filters.users.companyFiltered" clearable class="w-64">
                        <Option v-for="companies in companies" :value="companies.value" :key="companies.value">{{ companies.label }}</Option>
                    </i-select>
                </div>
                <div class="ml-2">
                    <p>Filtrar por vendedor</p>
                    <i-select filterable @on-change="() => loadChart(charts[1])" v-model="filters.users.salerFiltered" clearable class="w-64">
                        <Option v-for="saler in salers" :value="saler.value" :key="saler.value">{{ saler.label }}</Option>
                    </i-select>
                </div>
                <div>
                    <p>Período</p>
                    <InputNumber @on-change="() => loadChart(charts[1])" :active-change="false" :max="36" :min="1" v-model="filters.users.period" class="ml-2"></InputNumber>
                </div>
                <div>
                    <p>Tipo de período</p>
                    <i-switch @on-change="() => loadChart(charts[1])" false-value="mensal" size="large" class="m-2"
                                true-value="semanal" v-model="filters.users.periodFilteredType">
                        <span slot="open">SEM</span>
                        <span slot="close">MEN</span>
                    </i-switch>
                </div>
            </div>
            <div>
                <spin size="large" fix v-show="false"></spin>
                <bar :options="userGraphOptions" @click="(options) => getDetails(options, charts[1])"></bar>
            </div>
            <div style="max-height:32rem;" class="overflow-auto" @scroll="handleScroll" v-show="table.users.show">
                <i-table :ref="charts[1]" :columns="table.users.columns" :data="table.users.data" :loading="table.users.loading" v-show="table.users.show"></i-table>
            </div>
        </vx-card>
    </div>
</template>

<script>
import ChartConfig from './ChartConfig.json';
import _ from 'lodash';
import { revendaApi } from "@/api/axios";

export default {
    name: 'ClientesLog',
    components: {
        bar: () => import("../../components/charts/BarChart")
    },
    data () {
        return {
            charts: ["companies", "users"],
            salers: [],
            companies:[],
            filters: {
                companies: {
                    period: 2,
                    periodFilteredType: 'semanal',
                    companyFiltered: 0,
                    salerFiltered: 0,
                },
                users: {
                    period: 2,
                    periodFilteredType: 'semanal',
                    companyFiltered: 0,
                    salerFiltered: 0,
                },
                alias: {
                    semanal: 'week',
                    mensal: 'month'
                }
            },
            companyGraphOptions: {},
            userGraphOptions: {},
            table: {
                companies: {
                    columns: [
                        {title: '#', key: 'id_empresa', sortable:true}, {title: 'quantidade', key: 'total', sortable:true},
                        {title: 'tempo médio de sessão', sortable:true, key: 'tempo_medio_sessao', align: 'right', render: (h, params) => {
                            return h('P',  this.formatTime(params.row.tempo_medio_sessao))
                        }}
                    ],
                    data: [],
                    loading: true,
                    show: false
                },
                users: {
                    columns: [
                        {title: '#', key: 'id_empresa', sortable:true}, {title: 'Usuário', key: 'id_usuario', sortable: true}, {title: 'quantidade', key: 'total', sortable:true},
                        {title: 'tempo médio de sessão', sortable:true, key: 'tempo_medio_sessao', align: 'right', render: (h, params) => {
                            return h('P',  this.formatTime(params.row.tempo_medio_sessao))
                        }}
                    ],
                    data: [],
                    loading: true,
                    show: false
                }
            }
        }
    },

    methods: {
        async loadCompanies()
        {
            /*const {data} = await this.$axios.get(`${process.env.VUE_APP_REVENDA_API_URL}clientes/list`);
            this.companies = data.map(client => {return {label:client.nome, value:client.id_pessoa, id_vendedor:client.id_vendedor}});*/
        },

        async loadSalers()
        {
            const {data} = await revendaApi.get('saler/all');
            this.salers = data.map(vendedor => {return {label:vendedor.nome, value:vendedor.id_pessoa}});
        },

        downloadCsvData(table)
        {
            this.$refs[table].exportCsv({
                filename: 'Sessão Usuários',
            });
        },
        refreshData(graph)
        {
            this.table[graph].show = false;
            this.loadChart(graph);
        },
        async getDetails(bar, chart)
        {
            if (!(this.filters[chart].companyFiltered) || (bar.seriesIndex == 0 && this.filters[chart].companyFiltered > 0)) {
                if (!bar.selected) {
                    this.table[chart].show = true;
                } else {
                    this.table[chart].show = false;
                    return;
                }
                const periodSelected = bar.name.split("-");
                const type = ["logged", "notlogged"];
                const selectedType = type[bar.seriesIndex];
                const period = `${periodSelected[2]}-${periodSelected[1]}-${periodSelected[0]}`;
                this.table[chart].loading = true
                revendaApi.get(`stats/${chart}/logs/details`, {params: {
                    periodSelected: period, periodType: this.filters.alias[this.filters[chart].periodFilteredType], type:selectedType,
                    salerId: this.filters[chart].salerFiltered, companyId: this.filters[chart].companyFiltered, offset: 100, total:bar.value
                }}).then(({data}) => {
                    this.table[chart].data = data;
                    this.table[chart].loading = false;
                })
            } else {
                this.table[chart].show = false;
            }
        },
        loadChart (chart) {
            this.getChartStats(chart).then((data) => {
                if (chart === this.charts[0]) {
                    this.loadCompanyChart(data);
                } else if (chart === this.charts[1]) {
                    this.loadUserChart(data);
                }
            });
        },

        async loadCompanyChart(data)
        {
            const dataSeries = (data.map(item => {
                    item = item.map(graph => graph.total);
                    return item;
                }));
            this.companyGraphOptions = {
                "grid": {
                    "left": 50,
                    "top": 50
                },
                "tooltip": {
                    "type": "shadow"
                },
                "backgroundColor": "#fff",
                "legend": {
                    "data": ["Logins", "Empresas que não efetuaram login", "Quantidade Empresas Cadastradas"]
                },
                "series":  [{
                        "name": "Logins",
                        "type": "bar",
                        "color": "#2E8B57",
                        "data": dataSeries[0],
                        "stack": "logs",
                        "label": {
                            "normal": {
                                "position": "inside",
                                "show": true,
                                "color": "#ffffff"
                            }
                        }
                    },
                    {
                        "name": "Empresas que não efetuaram login",
                        "type": "bar",
                        "color": "#3CB371",
                        "data": dataSeries[1],
                        "stack": "logs",
                        "label": {
                            "normal": {
                                "position": "inside",
                                "show": true,
                                "color": "#ffffff"
                            }
                        }
                    },
                    {
                        "name": "Quantidade Empresas Cadastradas",
                        "type": "line",
                        "color": "#8FBC8F",
                        "data": dataSeries[2],
                        "markLine":{
                            "lineStyle":{
                                "color":'#00FFFF'
                            }
                        },
                    }],
                "yAxis": {
                    "value": "category"
                },
                "xAxis": {
                    "data": _.uniqBy(data[0], 'period').map(period => {
                            const periods = period.period.split('-');
                            return `${periods[2]}-${periods[1]}-${periods[0]}`;
                        }),
                    "type": "category",
                    "axisLine": {"onZero": true},
                    "splitLine": {"show": false},
                    "splitArea": {"show": false}
                }
            }
        },
        async loadUserChart (data) {
            this.userGraphOptions = {
                "grid": {
                    "left": 50,
                    "top": 50
                },
                "tooltip": {
                    "type": "shadow"
                },
                "backgroundColor": "#fff",
                "legend": {
                    "data": ["Logins"]
                },
                "series": [
                    {
                        "name": "Logins",
                        "type": "bar",
                        "color": "#2E8B57",
                        "data": data.map(item => item.total),
                        "label": {
                            "normal": {
                                "position": "inside",
                                "show": true,
                                "color": "#ffffff"
                            }
                        }
                    }
                ],
                "yAxis": {
                    "value": "category"
                },
                "xAxis": {
                    "data": _.uniqBy(data, 'period').map(period => {
                            const periods = period.period.split('-');
                            return `${periods[2]}-${periods[1]}-${periods[0]}`;
                        }),
                    "type": "category",
                    "axisLine": {"onZero": true},
                    "splitLine": {"show": false},
                    "splitArea": {"show": false}
                }
            }
        },
        formatTime(seconds)
        {
            return seconds < 60 ? `${seconds} s` : (seconds < 3600 ? `${(seconds / 60).toFixed(2)} m` : `${(seconds / (60 * 60)).toFixed(2)} h`);
        },
        async getChartStats(chart)
        {
            const alias = {"semanal":"week", "mensal":"month"};
            const {data} = await revendaApi.get(`stats/${chart}/logs`, {
                params: {
                    period: this.filters[chart].period, periodType:alias[this.filters[chart].periodFilteredType], salerId: this.filters[chart].salerFiltered, companyId: this.filters[chart].companyFiltered
                }
            })
            return data;
        },
        handleScroll: _.debounce(async function ({target}) {
            let windowRelativeBottom = target.scrollHeight - target.offsetHeight;
            if (target.scrollTop > windowRelativeBottom - 50) {
                console.log("Busca mais dados");
            }
        }, 500)
    },

    async created()
    {
        this.loadCompanies();
        this.loadSalers();
        await this.loadChart(this.charts[0]);
        await this.loadChart(this.charts[1]);
    }
}
</script>

<style scoped>

</style>
